export enum Types {
  SAVE_CHANGES = 'CampaignEditor:SaveChanges',
  DISCARD_CHANGES = 'CampaignEditor:DiscardChanges',
  DELETE_RULESET = 'CampaignEditor:DeleteRuleset',
  CLEAR_RULESET = 'CampaignEditor:ClearRuleset',
}

export interface EmptyAction {
  type: Types.SAVE_CHANGES | Types.DISCARD_CHANGES;
}

export interface SaveChanges {
  type: Types.SAVE_CHANGES;
  payload?: {
    siteId: string;
  };
}

export interface RulesetDeleted {
  type: Types.DELETE_RULESET;
  payload: {
    rulesetId: string;
  };
}

export interface RulesetCleared {
  type: Types.CLEAR_RULESET;
}

export type Action = EmptyAction | RulesetDeleted | SaveChanges | RulesetCleared;
